import { createContext } from 'react';
import { InternationalisationContextValue } from './types/InternationalisationContextValue';

export const InternationalisationContext = createContext<
  InternationalisationContextValue | undefined
>(undefined);
